import { useState as a, useMemo as d, useEffect as y } from "react";
function j(r) {
  const [u, f] = a(Object.keys(r).reduce((e, t) => (e[t] = r[t].default, e), {})), c = d(() => Object.keys(r), [r]), [s, l] = a({}), [m, i] = a(c.reduce((e, t) => (e[t] = !1, e), {})), h = d(() => Object.keys(s).length === 0, [s]);
  function g(e) {
    return (t) => {
      const n = typeof t == "object" && t.target != null ? t.target.value : t;
      f((o) => ({
        ...o,
        [e]: n
      }));
    };
  }
  function F(e) {
    return (t) => {
      i((n) => ({
        ...n,
        [e]: !0
      }));
    };
  }
  function b() {
    f(c.reduce((e, t) => (e[t] = r[t].default, e), {}));
  }
  y(() => {
    l(c.reduce((e, t) => {
      for (const n of r[t].validations ?? []) {
        const o = n(u[t], u);
        if (o != null) {
          e[t] = o;
          break;
        }
      }
      return e;
    }, {}));
  }, [u]);
  function k() {
    i((e) => Object.fromEntries(
      Object.keys(e).map((t) => [t, !0])
    ));
  }
  return {
    /**
      * Key value pairs of form field names and their values
      */
    formData: u,
    /**
      * Key value pairs of form field names and their
      * validation errors
      */
    errors: s,
    /**
      * Key value pairs of form field names and whether
      * they have been interacted with
      */
    touched: m,
    isFormValid: h,
    handleInputChange: g,
    handleBlur: F,
    resetForm: b,
    showValidations: k
  };
}
export {
  j as default
};
